(function() { window.GUID_e529ade4_9132_4275_955f_282e2c186eb8 = { getGuid: function() { return "e529ade4-9132-4275-955f-282e2c186eb8"; } }; })();
//namespace CS.Controls {
//    export class Link {
//        ///Appeler dans _smart-mapper.cshtml
//        public static HandleAnchorsClick() {
//            CS.DOM.$body.offon('click.a', 'a:not(.external,.ui-state-disabled)', function (e) {
//                e.preventDefault();
//                let href = $(this).attr('href'); 
//                if (href == "#") {
//                    return;
//                }
//                CS.Nav.Go(href);
//            });
//        }
//    }
//}

//# sourceMappingURL=link.js.map
